import { off, on } from '@ifit/native-webview-interface';
import { useQueryClient } from 'react-query';
import { useEffect } from 'react';

export const useInvalidateOnCallJavaScript = (methodNames, queryKey) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const invalidate = evt => {
      if (methodNames.includes(evt.methodName)) {
        //timeout is to help prevent refetch from outpacing call to update favorite status
        setTimeout(() => queryClient.invalidateQueries(queryKey), 2000);
      }
    };

    on('callJavaScript', invalidate);
    return () => off('callJavaScript', invalidate);
  }, [queryKey, methodNames, queryClient]);
};
